import styled from "styled-components";

export const PremiumPubLocationWrapper = styled.div`
  padding: 20px 16px 50px;

  #map {
    margin-top: 12px;
    width: 100%;
    height: 240px;
    border-radius: 8px;
  }
`;

export const PremiumPubLocationText = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--Black-300, #808080);
  font-size: 14px;
  font-weight: 400;

  > img {
    width: 16px;
    height: 16px;
  }
`;

export const PremiumPubLocationButton = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: rgba(100, 54, 231, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;

  > img {
    width: 20px;
    height: 20px;
  }
`;
